import { Menu, MenuItem } from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import {
	Button,
	useMutation,
	useNotify,
	useQueryWithStore,
	useRefresh,
	useTranslate,
	useUnselectAll,
} from "react-admin";

const ChangeStatusButton = ({ selectedIds }) => {
	const [anchorEl, setAnchorEl] = useState(null);
	const [status, setStatus] = useState(null);
	const translate = useTranslate();
	const refresh = useRefresh();
	const notify = useNotify();
	const unselectAll = useUnselectAll();

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const [updateStatus] = useMutation(
		{
			type: "post",
			resource: "user-payments/change-status",
			payload: {
				body: { selectedIds, status },
			},
		},
		{
			onSuccess: () => {
				notify(
					translate("resources.user-payments.messages.change_status_success")
				);
				refresh();
				unselectAll("user-payments");
			},
			onError: () => {
				notify(
					translate("resources.user-payments.messages.change_status_fail"),
					"warning"
				);
			},
		}
	);

	useEffect(() => {
		if (status) {
			updateStatus();
			handleClose();
			setStatus(null);
		}
	}, [status, updateStatus]);

	const { data, loading } = useQueryWithStore({
		type: "getList",
		resource: "user-payment-statuses",
		payload: {
			pagination: {
				perPage: 50,
				page: 1,
			},
			sort: {
				field: "id",
				direction: "ASC",
			},
			filter: {
				only_manual: true,
			},
		},
	});

	return (
		<Fragment>
			<Button
				label={translate("resources.user-payments.button.change_status")}
				onClick={handleClick.bind(this)}
			/>
			<Menu
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleClose}
			>
				{!loading &&
					data &&
					data.map((status) => (
						<MenuItem key={status.id} onClick={setStatus.bind(this, status)}>
							{translate(`resources.user_payment_statuses.code.${status.code}`)}
						</MenuItem>
					))}
			</Menu>
		</Fragment>
	);
};
export default ChangeStatusButton;
